import React from "react"

import { css } from "@jsUtils"
import { metaData } from "@data"

import BarColor from "@assets/svg/bar-color.svg"

import Styles from "./social.module.scss"

const {
  socialNetwork: { linkedin, twitter, facebook, instagram, spotify }
} = metaData

const Social = ({ parentClass, hidden }) => {
  const tabbing = hidden ? -1 : 0
  return (
    <div className={css(Styles.social, !!parentClass && parentClass)}>
      <BarColor />
      <ul>
        <li>
          <a href={linkedin} title="LinkedIn" tabIndex={tabbing}>
            In.
          </a>
        </li>
        <li>
          <a href={twitter} title="Twitter" tabIndex={tabbing}>
            Tw.
          </a>
        </li>
        <li>
          <a href={facebook} title="Facebook" tabIndex={tabbing}>
            Fb.
          </a>
        </li>
        <li>
          <a href={instagram} title="Instagram" tabIndex={tabbing}>
            Ig.
          </a>
        </li>
        <li>
          <a href={spotify} title="Spotify" tabIndex={tabbing}>
            Sp.
          </a>
        </li>
      </ul>
    </div>
  )
}

export default Social
